<script>

</script>

<div class="content">
    <img src="images/loading.svg" alt="loading">
    <p>Loading Heatmap</p>
</div>

<style>
    .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        width: 100vw;
        height: 100vh;

        background-color: #F1F2F4;
        color: #2E2E30;

        font-size: 2.25em;
        font-weight: bold;
    }

</style>